// extracted by mini-css-extract-plugin
module.exports = {"cards":"Category_cards__28M8L","title":"Category_title__Jcet2"};